export { FontAwesomeIcon as Icon } from "@fortawesome/react-fontawesome";
